var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#E53935",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9974 8.29297C11.7402 8.29297 8.28906 11.7441 8.28906 16.0013C8.28906 20.2585 11.7402 23.7096 15.9974 23.7096C20.2546 23.7096 23.7057 20.2585 23.7057 16.0013C23.7057 11.7441 20.2546 8.29297 15.9974 8.29297ZM7.03906 16.0013C7.03906 11.0538 11.0498 7.04297 15.9974 7.04297C20.9449 7.04297 24.9557 11.0538 24.9557 16.0013C24.9557 20.9489 20.9449 24.9596 15.9974 24.9596C11.0498 24.9596 7.03906 20.9489 7.03906 16.0013ZM15.9974 12.043C16.3426 12.043 16.6224 12.3228 16.6224 12.668V16.0013C16.6224 16.3465 16.3426 16.6263 15.9974 16.6263C15.6522 16.6263 15.3724 16.3465 15.3724 16.0013V12.668C15.3724 12.3228 15.6522 12.043 15.9974 12.043ZM15.3724 19.3346C15.3724 18.9895 15.6522 18.7096 15.9974 18.7096H16.0057C16.3509 18.7096 16.6307 18.9895 16.6307 19.3346C16.6307 19.6798 16.3509 19.9596 16.0057 19.9596H15.9974C15.6522 19.9596 15.3724 19.6798 15.3724 19.3346Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toastError.a83199423833531f533ab5a5f9192969.svg";
export { ForwardRef as ReactComponent };